import { Injectable } from '@angular/core';
import { GoogleMapsLoaderService } from './google-maps-loader.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  private googleMapsStatus: { loaded: boolean; error?: string } = { loaded: false };

  constructor(private googleMapsLoader: GoogleMapsLoaderService) {}

  init(): Promise<any> {
    return new Promise((resolve) => {
      this.googleMapsLoader.waitForGoogleMaps()
        .then(() => {
          this.googleMapsStatus = { loaded: true };
          resolve(true);
        })
        .catch((error) => {
          this.googleMapsStatus = { loaded: false, error: error.message };
          resolve(true);
        });
    });
  }

  getGoogleMapsStatus(): { loaded: boolean; error?: string } {
    return this.googleMapsStatus;
  }
}
